import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[500],
};

export const paperProps: SxStyle = {
  mt: 1,
  border: '1px solid',
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(0.5),
  boxShadow: 'none',
};

export const row: SxStyle = {
  width: (p) => p.spacing(30),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};
